import { CONSUMER_APP_SOURCE } from '@upflowy/types';
import React, { ReactNode } from 'react';

import { EVENT_TYPE_REDIRECT } from '../helpers';
import { useApp } from '../providers/app-provider';

type HTMLAnchorElementTarget = '_self' | '_blank' | '_parent' | '_top' | 'framename';

interface LinkProps {
  href: string;
  target: HTMLAnchorElementTarget;
  children: ReactNode;
}

const Link: React.FC<LinkProps> = ({ href, target = '_self', children }) => {
  const { isStandaloneApp, containerId, origin } = useApp();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    if (!isStandaloneApp) {
      e.preventDefault();
      window.parent.postMessage(
        {
          source: CONSUMER_APP_SOURCE,
          containerId,
          redirectUrl: href,
          type: EVENT_TYPE_REDIRECT,
        },
        origin ?? '',
      );
    }
  };

  return (
    <a href={href} onClick={(e) => handleClick(e)} target={target}>
      {children}
    </a>
  );
};

export default Link;
